import * as React from 'react';

import { IItemsType, ICurrency, ITWPTicketOrderItem } from './types';
import { returnTicketTotalAmount } from './helpers';
import t from '../CartIn/helpers';

import OrderItemView from './OrderItemView';
import OrderItemPriceView from './OrderItemPriceView';
import Price from '../Shared/Price';
import OrderItemNumberSelect from './OrderItemNumberSelect';
import { getLocale } from '../utils/pathHelper';

interface IOrderItemProps {
  item: ITWPTicketOrderItem;
  itemsType: IItemsType;
  handleChange: (event: React.ChangeEvent) => void;
  handleRemove: (evnet: React.MouseEvent) => void;
  index: number;
  localCurrency?: ICurrency;
}

const TWPTicketOrderItem = ({
  item,
  itemsType,
  handleChange,
  handleRemove,
  index,
  localCurrency,
}: IOrderItemProps) => {
  const plan = item.ticket.plans.find(p => p.planId === item.planId)
  const locale: string = getLocale() || 'en';
  return (
    <OrderItemView key={`ticket-order-item-${index}`}>
      <div>
        <p className="name">
          <span>{item.ticket.name}</span>
          <span style={{marginLeft: '6px', marginRight: '6px'}}> </span>
          <span>{plan.name}</span>
        </p>
        <div>
          <p>{t.numPassengers()}</p>
          <OrderItemNumberSelect
            selectedNumber={item.adultQuantity}
            handleChange={handleChange}
            itemsType={itemsType}
            propKey="adultNum"
            index={index}
            max={10}
          />
        </div>
      </div>
      <OrderItemPriceView>
        <div className='item-price'>
          <Price
            price={returnTicketTotalAmount(plan.adultSellingPrice, item.adultQuantity)}
            fontSize={14}
            localCurrency={localCurrency}
          />
          {locale !='ja' &&
            <a
              href="#"
              onClick={handleRemove}
              data-index={index}
              data-items-type={itemsType}
              className="trash"
            >
              <i className="fas fa-trash" />
            </a>
          }
        </div>

        {locale =='ja' &&
          <a href="#" onClick={handleRemove} data-index={index} data-items-type={itemsType} className="remove-item">
            <i className="fas fa-trash" />
            カートから削除
          </a>
        }
      </OrderItemPriceView>
    </OrderItemView>
  );
};

export default TWPTicketOrderItem;
